import React, {ReactElement} from 'react';
import {useMoneyLeft} from 'ui/utils/core';

import {useDispatch} from 'ui/store';
import {useUIStore} from 'store/UI';
import {createFromNumber} from 'store/UserInput';

import {Center} from 'components/Center';
import {Header} from 'components/Header';
import {SettingsMenu} from 'components/SettingsMenu';
import {Credits} from 'components/Credits';
import {Budget} from 'components/Settings';
import {Animate} from 'components/Animate';
import {Wrapper, Compensator} from './style';

export const SettingsView = (): ReactElement => {
  const {settingsVisible} = useUIStore();
  const createKeyboardFromBudget = useDispatch(createFromNumber, useMoneyLeft());

  return (
    <Animate mount={settingsVisible} beforeMount={createKeyboardFromBudget}>
      <Wrapper>
        <Compensator>
          <Center>
            <Header>
              <SettingsMenu />
            </Header>

            <Budget />
            <Credits />
          </Center>
        </Compensator>
      </Wrapper>
    </Animate>
  );
};
